import { Box } from "@mui/material"
import MarketplaceOrderList from "@pages/main/marketplace_orders/sub_components/MarketplaceOrderList"
import MarketplaceOrderVisualizerDrawer from "@pages/main/marketplace_orders/sub_components/MarketplaceOrderVisualizerDrawer"
import { useState } from "react"

export default function MarketplaceOrdersPage() {
  const [selectedMarketplaceOrder, setSelectedMarketplaceOrder] = useState<
    string | null
  >(null)

  const handleSelectOrder = (orderId: string) => {
    setSelectedMarketplaceOrder(orderId)
  }

  const handleCloseVisualizer = () => {
    setSelectedMarketplaceOrder(null)
  }

  return (
    <Box sx={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Box
        sx={{
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column"
        }}
      >
        <MarketplaceOrderList onSelectOrder={handleSelectOrder} />
      </Box>
      <MarketplaceOrderVisualizerDrawer
        open={!!selectedMarketplaceOrder}
        onClose={handleCloseVisualizer}
        orderId={selectedMarketplaceOrder}
      />
    </Box>
  )
}
